import * as React from 'react';
import TextFit from 'react-textfit';
import { Flex, IBoxProps, Text } from '@lce/slice';
import WrapSymbols from '../../ui/WrapSymbols';

import { BannerLink, Container } from '../../ui';
import Sprites from '../../ui/assets/sprites.png';
import { scriptFunction } from '../../lib/util';
import * as Styled from './PromoBanner.style';
import { Image, Script } from '../../lib/banners/types';

export interface IPromoBannerProps extends IBoxProps {
  heading: string;
  images: Image[];
  imageFirst?: boolean;
  legal?: string;
  link?: {
    url: string;
    text: string;
  };
  promo: string;
  promoInstructions?: string;
  subheading?: string;
  template?: string;
  text?: string;
  script: Script;
}

export const PromoBanner: React.FC<IPromoBannerProps> = ({
  heading,
  images,
  imageFirst = true,
  legal,
  link,
  promo,
  promoInstructions,
  script: { text: scriptText, size },
  subheading,
  template,
  text,
  ...props
}) => {
  let promoImage = images[0];

  const selectImages = function(images: Image[]) {
    Object.keys(images).forEach(function(key: any) {
      if (images[key].type.toLowerCase().includes('promo')) {
        promoImage = images[key];
      }
      return;
    });
    return;
  };

  selectImages(images);

  const bannerLinkId = link?.url ? `click-home-${promo}` : '';

  return (
    <Styled.PromoBanner as="section" {...props}>
      <Container px={[2, 5]}>
        <BannerLink href={link?.url} id={bannerLinkId} title={link?.text}>
          <Styled.FlexContainer>
            <Styled.ImageWrapper flex={['initial', 'initial', '1 0 40%']} imageFirst={imageFirst}>
              <Styled.Image alt={promoImage.alt} src={promoImage.url} />
            </Styled.ImageWrapper>
            <Styled.TextBox flex={['initial', 'initial', '2 1 auto']}>
              {scriptText && (
                <Styled.Script
                  fontSize={scriptFunction(size, 'PromoBanner')}
                  lineHeight={0.8}
                  paddingTop={[0, 8]}
                  tilt={3}
                >
                  {scriptText}
                </Styled.Script>
              )}
              <Styled.Heading as="h2">
                <WrapSymbols string={heading} wrapper={Styled.Sup} />
              </Styled.Heading>
              <Styled.Subheading as={Text}>{subheading}</Styled.Subheading>
              {text && <Styled.Details>{text}</Styled.Details>}
              {promoInstructions && <Styled.PromoInstructions pt={4}>{promoInstructions}</Styled.PromoInstructions>}
              <Flex alignItems="center" justifyContent="center" pb={6}>
                <Styled.LeftSprites src={Sprites} />
                <Styled.Promo as={Text}>
                  <TextFit max={52} mode="single">
                    {promo}
                  </TextFit>
                </Styled.Promo>
                <Styled.RightSprites src={Sprites} />
              </Flex>
              {legal && <Styled.Legal>{legal}</Styled.Legal>}
            </Styled.TextBox>
          </Styled.FlexContainer>
        </BannerLink>
      </Container>
    </Styled.PromoBanner>
  );
};
